import React, { useState } from "react";
import { CgMenuRight } from "react-icons/cg";

import { IoMdClose } from "react-icons/io";
//import logo from "../../../images/logo2.png";
// import logo from "../../../images/logo3.png";
// import logo from "../../../images/logo4.png";
import logo from "../../../images/logo6.png";
// import logo from "../../../images/logo7.png";

import CallToAction from "../../shared/CallToAction";
import { scrollToSection } from "../../utils/helpers";

import "./style.scss";

const Navigation = () => {
    const [mobileMenu, setMobileMenu] = useState(false);

    const menuItemClickHandler = (section) => {
        setMobileMenu(false); // Close the mobile menu
        scrollToSection(section);
    };

    return (
        <div className="top-navigation-bar">
            <div className="app-logo">
                <img
                    src={logo}
                    alt="sandesh logo"
                />
            </div>
            <div
                className="mobile-menu"
                onClick={() => setMobileMenu(!mobileMenu)}
            >
                {mobileMenu ? (
                    <IoMdClose
                        size={24}
                        color="#fff"
                    />
                ) : (
                    <CgMenuRight
                        size={24}
                        color="#fff"
                    />
                )}
            </div>
            <div className={`navigation ${mobileMenu ? "active" : ""}`}>
                <span
                    className="navigation-item"
                    onClick={() => menuItemClickHandler("about")}
                >
                    About 
                </span>
                <span
                    className="navigation-item"
                    onClick={() => menuItemClickHandler("skills")}
                >
                    Tech Stack
                </span>
                <span
                    className="navigation-item"
                    onClick={() => menuItemClickHandler("projects")}
                >
                    Projects
                </span>
                <span
                    className="navigation-item"
                    onClick={() => menuItemClickHandler("blogs")}
                >
                    Blogs & Articles
                </span>
                <CallToAction
                    text="Contact"
                    id="navContactMe"
                    action={() => {
                        menuItemClickHandler("contact");
                    }}
                />
            </div>
        </div>
    );
};

export default Navigation;
